import React, { useState } from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react/button";
import { Popup } from "devextreme-react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import { WMTransactionType } from "../../../../const/constants";
import CustomerInfoForm from '../../../../id/common/customer/CustomerInfoForm';
import CustomerCredit from '../../../../id/common/customer/CustomerCredit';
import SummaryTab from '../../../../id/common/customer/SummaryTab';
import AdditionalTab from './AdditionalTab';
import OpenTransactionsTab from './OpenTransactionsTab';
import ItemMasterTab from './ItemMasterTab';
import '../../../../common/css/searchPage.css';

// The Primary tab's customer master + default-address block is the shared
// CustomerInfoForm; the single customer fetch it performs is handed back through
// onCustomerLoaded so the Additional tab reuses it.
const PrimaryTab = (props) => {
    const [customer, setCustomer] = useState(null);
    const [showCustomerCreditForm, setShowCustomerCreditForm] = useState(false);
    const [showSummaryForm, setShowSummaryForm] = useState(false);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <Toolbar className="header">
                    <Item location="before">
                        <div className="title">
                            <h6 style={{ color: window._env_.Color2, marginLeft: '12px' }}>WM Customer Query</h6>
                        </div>
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={props.onBack} text="Back" />
                    </Item>
                </Toolbar>
                <TabPanel>
                    <TabItem title="Primary">
                        <div style={{ padding: '8px 12px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                            <Button
                                text="Show Customer Summary"
                                type="default"
                                onClick={() => { if (props.id) setShowSummaryForm(true); }}
                            />
                            <Button
                                text="Show Customer Credit Status"
                                type="default"
                                onClick={() => { if (props.id) setShowCustomerCreditForm(true); }}
                            />
                        </div>
                        <CustomerInfoForm
                            id={props.id}
                            layoutId='9C1E5A73-4B2D-4E6F-8A10-7D3B2C6F9E4A'
                            layoutName='TransactionsByCustomerPrimaryForm'
                            onCustomerLoaded={setCustomer}
                        />
                    </TabItem>
                    <TabItem title="Additional">
                        <AdditionalTab id={props.id} customer={customer} />
                    </TabItem>
                    <TabItem title="Open Receipts">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.Receipt}
                            primaryGridKey="C4D1F8A6-2B93-4E70-8A15-9D3C6E42B71F"
                            detailGridKey="8E52A1C7-4F60-4D93-B2A8-1C7E60D3F9B4"
                            chargesGridKey="3B9E71C4-8A02-4F65-9D18-5E2C71B40A6D"
                        />
                    </TabItem>
                    <TabItem title="Open Shipments">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.Shipment}
                            primaryGridKey="A1607B34-5D28-4C91-8E70-2F9B4D6A3C15"
                            detailGridKey="B2718C45-6E39-4DA2-9F81-30AC5E7B4D26"
                            chargesGridKey="C3829D56-7F4A-4EB3-A092-41BD6F8C5E37"
                        />
                    </TabItem>
                    <TabItem title="Adjustment">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.Adjustment}
                            primaryGridKey="D4930E67-8A5B-4FC4-B1A3-52CE7F9D6E48"
                            detailGridKey="E5A41F78-9B6C-4AD5-C2B4-63DF80AE7F59"
                            chargesGridKey="F6B52A89-AC7D-4BE6-D3C5-74E091BF806A"
                        />
                    </TabItem>
                    <TabItem title="Open Storage">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.Storage}
                            primaryGridKey="1A7C3E95-2B48-4D60-9E15-8F3A6D0C4B72"
                            detailGridKey="2B8D4FA6-3C59-4E71-AF26-9040B7E1D5C8"
                            chargesGridKey="3C9E50B7-4D6A-4F82-B037-A151C8F2E6D9"
                        />
                    </TabItem>
                    <TabItem title="Open Miscellaneous">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.Miscellaneous}
                            primaryGridKey="4D0F61C8-5E7B-4A93-C148-B262D9F3A7E0"
                            detailGridKey="5E1A72D9-6F8C-4BA4-D259-C373E0A4B8F1"
                            chargesGridKey="6F2B83EA-708D-4CB5-E360-D484F1B5C902"
                        />
                    </TabItem>
                    <TabItem title="All Open Transactions">
                        <OpenTransactionsTab
                            id={props.id}
                            transactionType={WMTransactionType.All}
                            primaryGridKey="7A3C94FB-819E-4DC6-F471-E595A2C6DA13"
                            detailGridKey="8B4DA50C-92AF-4ED7-A582-F6A6B3D7EB24"
                            chargesGridKey="9C5EB61D-A3B0-4FE8-B693-07B7C4E8FC35"
                        />
                    </TabItem>
                    <TabItem title="Item Master">
                        <ItemMasterTab id={props.id} />
                    </TabItem>
                </TabPanel>
            </div>
            {showCustomerCreditForm && (
                <Popup
                    visible={showCustomerCreditForm}
                    onHiding={() => setShowCustomerCreditForm(false)}
                    width="90vw"
                    height="90vh"
                    title="Customer Credit Status"
                    showCloseButton={true}
                >
                    <CustomerCredit customerId={props.id} module="OM" />
                </Popup>
            )}
            {showSummaryForm && (
                <Popup
                    visible={showSummaryForm}
                    onHiding={() => setShowSummaryForm(false)}
                    width="60vw"
                    height="40vw"
                    title="Customer Summary Screen"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                        <SummaryTab customerId={props.id} />
                    </div>
                </Popup>
            )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
